import React from 'react';
import type { ObservationType } from 'types/surf';

interface ObservationIconProps {
  className?: string;
  type: ObservationType;
}

const ObservationIcon: React.FC<ObservationIconProps> = ({ className, type }) => {
  if (type === 'MULTIPLE') {
    return (
      <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="observation-icon-multiple"
      >
        <path
          d="M8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8C4 5.79086 5.79086 4 8 4ZM8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5Z"
          fill="#171717"
        />
      </svg>
    );
  }
  if (type === 'CAMERA') {
    return (
      <svg
        className={className}
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="observation-icon-camera"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 5C14 6.65685 12.6569 8 11 8C9.34315 8 8 6.65685 8 5C8 3.34315 9.34315 2 11 2C12.6569 2 14 3.34315 14 5ZM16 5C16 7.76142 13.7614 10 11 10C8.58104 10 6.56329 8.28224 6.10002 6H0V4H6.10002C6.56329 1.71776 8.58104 0 11 0C13.7614 0 16 2.23858 16 5Z"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="observation-icon-human"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 11.9999C3.34315 11.9999 2 10.6567 2 8.99988C2 7.34302 3.34315 5.99988 5 5.99988C6.65685 5.99988 8 7.34302 8 8.99988C8 10.6567 6.65685 11.9999 5 11.9999ZM5 13.9999C2.23858 13.9999 0 11.7613 0 8.99988C0 6.58092 1.71776 4.56317 4 4.0999L4 0.00012207L6 0.00012207V4.0999C8.28224 4.56317 10 6.58092 10 8.99988C10 11.7613 7.76142 13.9999 5 13.9999Z"
      />
    </svg>
  );
};

export default ObservationIcon;
